import * as tslib_1 from "tslib";
import * as moment from 'moment';
import { InputDateComponent } from '../input-date/input-date.component';
import { LocalisationService } from '../../../core/localisation.service';
/**
 * Class for input component for birthday input.
 */
var InputBirthdayComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputBirthdayComponent, _super);
    /**
     * Initializes a new instance of the InputBirthdayComponent.
     */
    function InputBirthdayComponent(localisationService) {
        var _this = _super.call(this, localisationService) || this;
        _this.placeholderKey = 'APP.INPUTS.DATE_PLACEHOLDER';
        /** The relative URL of the picture celebrating one's birthday. */
        _this.celebrateUrl = require('../../assets/images/hooray.png');
        return _this;
    }
    Object.defineProperty(InputBirthdayComponent.prototype, "birthdayString", {
        /**
         * Gets the format for displaying birthdays in readonly.
         */
        get: function () {
            return this.localisationService.currentLanguage.formats.agenda.week.start;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a value indicating whether the set birthday is today.
     */
    InputBirthdayComponent.prototype.isBirthdayToday = function () {
        if (!this.valueAsMoment) {
            return false;
        }
        return this.valueAsMoment.date() === moment().date() && this.valueAsMoment.month() === moment().month();
    };
    return InputBirthdayComponent;
}(InputDateComponent));
export { InputBirthdayComponent };
